import React from 'react';
import Search from './Search';
import Download from './Download';
import classNames from 'classnames';
import Button, {buttonProps} from './Button';
import CardSort from './CardSort';
import BackIcon from '../../../assests/img/back.svg?react';
import '../../../assests/css/contentheader.scss';


export interface contentHeaderProps {
    title: string,
    ctaProps: buttonProps,
    showWholesalers: boolean,
    onWholesalersSelect: (selected: boolean) => void,
    count?: number,
    showDownload?: boolean,
    showSort?: boolean,
    customClass?: string,
    onSearch?: (text: string) => void,
    showAdd?: boolean,
}

export default function ContentHeader(props: contentHeaderProps) {

    const {title, count, showDownload, customClass, ctaProps,
    showWholesalers, onWholesalersSelect, onSearch,
    showSort, showAdd} = props;

    return (
        <div className={classNames("content-header-container", customClass ? customClass : '')}>
            <div className="content-header-items">
                <div className="content-header-title">
                    {showWholesalers? <div
                        className="content-header-back"
                        onClick={()=>onWholesalersSelect(false)}>
                        <BackIcon width={32} height={32}/> </div>: null}
                    <div>{title}</div>
                    <div className="content-header-count">
                        {count? `(${count})`: '(0)'}
                    </div>
                </div>
                <Search onChange={onSearch}/>
                <div className="content-header-download-info">
                    {showSort ? <CardSort/> : null}
                    {showAdd ? <Button {...ctaProps}></Button> : null}
                    {showDownload ? <Download/> : null}
                </div>
            </div>
        </div>
    );

}